import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { ProdutosService} from  '../../shared/services/api/cadastros/ProdutosService';
import { useDebounce } from '../../shared/hooks';
import { useField } from '@unform/core';


type TAutoCompleteOption = {
  idprod: string;
  label: string;
}

interface IAutoCompleteFabricaProps {
  isExternalLoading?: boolean;
  uuidprod?: (novoTextoselect: string | undefined) => void;
  nome?: (novoTextoselect: string | undefined) => void;
}
export const AutoCompleteProdutos: React.FC<IAutoCompleteFabricaProps> = ({ isExternalLoading = false, uuidprod, nome }) => {

  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>('');

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  // useEffect(() => {
  //   registerField({
  //     name: fieldName,
  //     getValue: () => selectedId,
  //     setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
  //   });
  // }, [registerField, fieldName, selectedId]);

  useEffect(() => {
    setIsLoading(true);
    debounce(() => {  
      ProdutosService.getAllList(selectedId, busca)
        .then((result) => { 
          setIsLoading(false); 

          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(produto => ({ idprod: produto.idprod, label: produto.descricao })));
          }
        });
    });
  }, [busca, selectedId]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idprod === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);


  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'
      disablePortal
      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => { setSelectedId(newValue?.idprod); uuidprod?.(newValue?.idprod); nome?.(newValue?.label); setBusca(''); }}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Produtos"
        />
      )}
    />
  );
};